module.exports = __webpack_public_path__ + "img/framenew_box12.09ed0c82.jpg";